import { useState } from 'react';
import { EnquiryClient, EnquiryDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useEnquiryApi = () => {
    const apiClient = new EnquiryClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: EnquiryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createEnquiry(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Enquiry');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: EnquiryDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateEnquiry(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Enquiry');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getEnquiryById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Enquiry');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchEnquiries(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Enquiries');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteEnquiry(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Enquiry');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};